// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__v7x7A","modal-content":"Modal_modal-content__OVjSR","active":"Modal_active__pn7uU"};